import { GET_OPTA } from '../../constants/actions/policy';

export function getOpta() {
    return {
        type: GET_OPTA,
    };
}
